jQuery('document').ready(function(){

    jQuery('body').on('click', '.plpCloseIMG', function(){
        jQuery('.plpNewsletter').hide();
    })


    if(jQuery(window).width() < 768) {
        jQuery('.plpPROMO').css("background-image", "url(" + jQuery('.plpPROMO').attr('data-mobile-bg') + ")");

        jQuery('.rewardLink').appendTo('.rewarditem.second');
    }

    jQuery('.plpPROMO').insertAfter(jQuery('.grid--view-items .grid__item').eq(5));

    if(jQuery('.collection-hero__title').text().trim().split(" ").length > 2) {
        jQuery('.collection-hero__title').html(jQuery('.collection-hero__title').text().trim().replace(' ','<br />'))
    } else {
        jQuery('.rowInner').addClass('small');
    }
    
    var textArray = jQuery('.collection-description').text().trim().replace(/([.?!])\s*(?=[A-Z])/g, "$1|").split("|")

    if(textArray.length > 1) {
       
        $('<div class="firstPara">' + textArray[0] + ' ' + textArray[1] + '</div>').appendTo( jQuery('.collection-hero__title-wrapper .rowInner').eq(1))


        
        if(textArray[2]) {

            $('<div class="secondPara">' + textArray[2] + '</div>').appendTo( jQuery('.collection-hero__title-wrapper .rowInner').eq(2))
        }

        if(textArray[3]) {
            jQuery('.secondPara').text( jQuery('.secondPara').text() + ' ' + textArray[3])
        }

        if(textArray[4]) {
            jQuery('.secondPara').text( jQuery('.secondPara').text() + ' ' + textArray[4])
        }
    } else {
        $('<div class="firstPara">' + textArray[0] + '</div>').appendTo( jQuery('.collection-hero__title-wrapper .rowInner').eq(1))
    }

    
});